import { Banner, Col, Row, Typography } from 'darrius';

import { FormLead } from '../../molecules/FormLead/FormLead';

import styles from './HeaderLead.module.scss';

interface IHeaderLeadProps {
  info: {
    headerProImage: {
      original: string;
    };
  };
  titleHeaderContent: string;
  homeDescription: string;
  title: string;
  text: string;
  formContent: {
    title: string;
    description: string;
    placeholder: string;
    sendButton: string;
  };
  friendlyName: string;
}

export function HeaderLead(props: IHeaderLeadProps) {
  const {
    info,
    titleHeaderContent,
    homeDescription,
    title,
    text,
    formContent,
    friendlyName,
  } = props;

  const professionalImage = info.headerProImage.original
    .replace('/images/', '/')
    .replace('www', 'images')
    .replace('professional_header_images', 'professional_header_images_b')
    .split('?')[0];

  return (
    <Banner as="section" className="full">
      <Row className="middle-md">
        <Col className={`col-sm-12 col-md-8 ${styles['text-pro']}`}>
          <Typography.Title className={`${styles['text-pro']}`}>
            {titleHeaderContent}
          </Typography.Title>

          <Typography.Text>{homeDescription}</Typography.Text>
        </Col>

        <Col className="col-sm-12 last-md">
          <Banner
            className={`${styles['form-lead']} form-lead`}
            size="2"
            title={title}
            text={text}
          >
            <FormLead
              order="first_form"
              content={formContent}
              direction="horizontal"
              buttonText="Cadastre-se gratuitamente"
            />
          </Banner>
        </Col>

        <Col className="col-sm-12 center-sm col-md-4">
          <img
            src={professionalImage}
            alt={friendlyName}
            width={290}
            height={387}
            className={styles['image-pro']}
          />
        </Col>
      </Row>
    </Banner>
  );
}

export default HeaderLead;
